import {mergeTo} from '#core/utils/config-utils.js';

import {AbstractVisualFeature, allVisuals} from '#core/application/modules/visual-feature.js';

import {getVideoStreamingConfig} from './factory.js';

import SCHEMA from './video-streaming.schema.yaml';
import PALETTE_SCHEMA from './video-streaming.palette-schema.yaml';

class VideoStreamingFeature extends AbstractVisualFeature {
    get name() {
        return 'Presentation/VideoStreaming';
    }

    get configSchema() {
        return SCHEMA;
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        const {
            autoPlayStreamDesktop,
            autoPlayStreamMobile,
            autoPlayStreamNative,
            hidePlayerWhenStreamEnded,
            includeCredentialsHostsList,
            rmg,
        } = this.config;

        return mergeTo(getVideoStreamingConfig(PALETTE), {
            VideoStream: {
                _desktop_autoPlayStream: autoPlayStreamDesktop,
                _mobile_autoPlayStream: autoPlayStreamMobile,
                _native_mobile_autoPlayStream: autoPlayStreamNative,
                hidePlayerWhenStreamEnded: hidePlayerWhenStreamEnded,
                rmgConfig: {
                    src: rmg.src,
                    'data-cssdiff': rmg.dataCssDiff,
                    'data-csspath': rmg.dataCssPath,
                    'data-responsive': rmg.dataResponsive,
                },
                providerContainer: {
                    PERFORMMCC_R: {
                        style: {
                            aspectRatio: rmg.ratio,
                            ...(rmg.maxWidth && {maxWidth: rmg.maxWidth}),
                        },
                    },
                },
                videoPlayer: {
                    includeCredentialsHosts:
                        includeCredentialsHostsList?.length > 0
                            ? includeCredentialsHostsList.reduce((reducer, host) => ({...reducer, [host]: true}), {})
                            : {},
                },
            },
        });
    }
}

export const VideoStreaming = new VideoStreamingFeature(allVisuals);
